import { INITIAL_MAP_CONFIG } from '~/constants/map';

export type PlaybackSpeed = 1 | 2 | 4;

export const JOURNEY_DEFAULT_PERSON_ID = 5209932;
export const JOURNEY_ERROR_AUTO_HIDE_MS = 5000;

export const JOURNEY_MAP_STYLE = 'mapbox://styles/mapbox/streets-v12';
export const JOURNEY_FLY_TO_ZOOM = 16;
export const JOURNEY_FLY_TO_DURATION_MS = 200;
export const JOURNEY_RESUME_PLAYBACK_ZOOM_MAX = 13;
export const JOURNEY_RESUME_PLAYBACK_ZOOM_MIN = 10;
export const JOURNEY_RESUME_PLAYBACK_ZOOM_THRESHOLD = JOURNEY_RESUME_PLAYBACK_ZOOM_MAX;
export const JOURNEY_SIDEBAR_PIN_MARKER = {
  width: 20,
  height: 30,
  offsetX: 0,
  offsetY: -2,
} as const;
export const JOURNEY_INITIAL_VIEW_STATE = {
  longitude: INITIAL_MAP_CONFIG.lng,
  latitude: INITIAL_MAP_CONFIG.lat,
  zoom: INITIAL_MAP_CONFIG.zoom,
} as const;

export const PLAYBACK_SPEED_OPTIONS: PlaybackSpeed[] = [1, 2, 4];

export const PLAYBACK_INTERVAL_BY_SPEED: Record<PlaybackSpeed, number> = {
  1: 1000, // dashcam speed
  2: 500,
  4: 250,
};

export const JOURNEY_QUERY_KEYS = {
  personId: 'person_id',
  startDate: 'startDate',
  endDate: 'endDate',
} as const;
